// Admin authentication is carried by an HTTP-only session cookie. Ensure generated API
// hooks and direct requests include the cookie without ever reading or storing credentials.
const originalFetch = window.fetch;
window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
  let url = '';
  if (typeof input === 'string') url = input;
  else if (input instanceof URL) url = input.toString();
  else if (input instanceof Request) url = input.url;

  if (url.includes('/api/admin')) {
    return originalFetch(input, { ...init, credentials: 'same-origin' });
  }
  return originalFetch(input, init);
};

export {};
